import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import levitatingImg from '../../../assets/images/levitating-paper.png';
import './ProjectPublishedModal.scss';

class ProjectPublishedModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
    };
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  render() {
    const { showModal } = this.state;
    const { referralUrl } = this.props;
    return (
      <div>
        <Modal show={showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton className="no-border-bottom" />
          <Modal.Body>
            <div className="project-published-modal style-guide">
              <img src={levitatingImg} alt="Clora" className="levitating-img" />
              <h1 className="mb-12">Clora is reviewing your project!</h1>
              <div className="body-text-1 mb-12">
                Before making it public, we want to ensure your project post
                best represents your company&#39;s needs.
              </div>
              <div className="body-text-1 mb-4">
                Your account manager will contact you shortly to schedule a scoping call.
              </div>
              <hr className="mt-0  mb-3 " />
              <div className="body-text-1">
                If you think Clora can benefit other employers in your network, check out
                our
                {' '}
                <strong>
                  Referral Program
                  <a
                    href={referralUrl}
                    target="_blank"
                    id="referral-from-published-project"
                    rel="noreferrer"
                  >
                    {' '}
                    here
                  </a>
                </strong>
                .
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

ProjectPublishedModal.propTypes = {
  referralUrl: PropTypes.string.isRequired,
};

export default ProjectPublishedModal;
